module.exports = __webpack_public_path__ + "static/media/Samurai Warrior.bc8ff8e7.jpg";